import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppLightModal from '@/components/AppLightModal.vue';
import AppRadio from '@/components/AppRadio.vue';
import { SnackType } from '@/interfaces/snack';
import { showErrors, showNotification } from '@/utils/snack';
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime';
import { auditOptions, auditStatusText, auditCodes } from '@/helpers/audit';
import { auditDealer as _auditDealer, deleteDealer, findDealer } from './gql';
import { AuditStatus } from '@/interfaces/status';

var DealerDialog = /*#__PURE__*/function (_Vue) {
  _inherits(DealerDialog, _Vue);

  var _super = _createSuper(DealerDialog);

  function DealerDialog() {
    var _this;

    _classCallCheck(this, DealerDialog);

    _this = _super.apply(this, arguments);
    _this.targetDealer = null;
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.utcDateTimeToDate = utcDateTimeToDate;
    _this.auditOptions = auditOptions();
    _this.auditCodes = auditCodes();
    _this.auditStatusText = auditStatusText;
    _this.AuditStatus = AuditStatus;
    _this.denyReason = '';
    _this.showAudit = false;
    _this.auditIndex = -1;
    _this.auditItems = [{
      text: '审核通过'
    }, {
      text: '审核不通过'
    }];
    _this.auditDialog = {
      show: false,
      title: '',
      text: ''
    };
    _this.denyDialog = {
      show: false,
      title: '审核不通过原因'
    };
    _this.deleteDialog = {
      show: false,
      title: '删除经销商',
      text: ''
    };
    return _this;
  }

  _createClass(DealerDialog, [{
    key: "onAuditDialogChanged",
    value: function onAuditDialogChanged(val) {
      if (!val) {
        this.auditIndex = -1;
      }
    }
  }, {
    key: "editHandler",
    value: function editHandler(item, type) {
      this.targetDealer = item;

      if (type === 'new') {
        this.$router.push({
          name: 'EditDealer',
          params: {
            type: type
          }
        });
      } else {
        this.$router.push({
          name: 'EditDealer',
          params: {
            type: type,
            id: item.id
          }
        });
      }
    }
  }, {
    key: "deleteHandler",
    value: function deleteHandler(item) {
      this.targetDealer = item;
      this.deleteDialog.text = "\u662F\u5426\u786E\u5B9A\u5220\u9664\u7ECF\u9500\u5546 \u201C".concat(item.realname, "\u201D ?");
      this.deleteDialog.show = true;
    }
  }, {
    key: "auditHandler",
    value: function auditHandler(item, choice) {
      var action = '';
      this.showAudit = false;

      switch (choice) {
        case 0:
          action = '通过';
          break;

        case 1:
          action = '不通过';
          break;

        default:
          break;
      }

      this.auditDialog.title = "\u5BA1\u6838".concat(action);
      this.auditDialog.text = "\u786E\u5B9A\u8981".concat(action, " \u201C").concat(item.realname, "\u201D \u7684\u5BA1\u6838\uFF1F");
      this.auditDialog.show = true;
    }
  }, {
    key: "showAuditPop",
    value: function showAuditPop(item) {
      this.targetDealer = item;
      this.showAudit = !this.showAudit;
    }
  }, {
    key: "deleteDealerById",
    value: function () {
      var _deleteDealerById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$targetDealer, result, typedError;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: deleteDealer,
                  variables: {
                    dealerId: Number((_this$targetDealer = this.targetDealer) === null || _this$targetDealer === void 0 ? void 0 : _this$targetDealer.id)
                  }
                });

              case 3:
                result = _context.sent;

                if (result) {
                  showNotification({
                    msg: '删除成功!',
                    type: SnackType.Info
                  });
                }

                this.deleteDialog.show = false;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function deleteDealerById() {
        return _deleteDealerById.apply(this, arguments);
      }

      return deleteDealerById;
    }()
  }, {
    key: "auditDealer",
    value: function () {
      var _auditDealer2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(status) {
        var _this$targetDealer2, result, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.mutate({
                  mutation: _auditDealer,
                  variables: {
                    dealerId: Number((_this$targetDealer2 = this.targetDealer) === null || _this$targetDealer2 === void 0 ? void 0 : _this$targetDealer2.id),
                    status: status,
                    denyReason: this.denyReason
                  }
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  showNotification({
                    msg: '操作成功!',
                    type: SnackType.Info
                  });
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function auditDealer(_x) {
        return _auditDealer2.apply(this, arguments);
      }

      return auditDealer;
    }()
  }, {
    key: "getDealerById",
    value: function () {
      var _getDealerById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dealerId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findDealer,
                  variables: {
                    dealerId: dealerId
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findDealer);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getDealerById(_x2) {
        return _getDealerById.apply(this, arguments);
      }

      return getDealerById;
    }()
  }]);

  return DealerDialog;
}(Vue);

__decorate([Watch('auditDialog.show')], DealerDialog.prototype, "onAuditDialogChanged", null);

DealerDialog = __decorate([Component({
  components: {
    AppTextField: AppTextField,
    AppSelector: AppSelector,
    AppRadio: AppRadio,
    AppLightModal: AppLightModal
  }
})], DealerDialog);
export default DealerDialog;